<template>
  <div class="company-details">
    <keep-alive>
      <b-list-group>
        <b-list-group-item class="company-header">
          <Header v-if="company.id" :company="company" :companyId="companyId" :isVendor="isVendor" />
        </b-list-group-item>

        <b-list-group-item id="upper-tab">
          <Toolbar
            :companyId="companyId"
            :companyName="company.name"
            :isCustomer="isCustomer"
            :isVendor="isVendor"
            :salesRep="company.salesPerson1UserId"
          />

          <UpperTab v-if="company.id" :companyId="companyId" :isVendor="isVendor" :companyClass="company.accountClassId" />
        </b-list-group-item>

        <!-- <b-list-group-item id="details-tab">
          <DetailsTab :companyId="companyId"/>
        </b-list-group-item> -->

        <b-list-group-item id="footer">
          <Footer :company="company.id"/>
        </b-list-group-item>
      </b-list-group>
    </keep-alive>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import Header from './components/Header/index';
import Toolbar from './components/Toolbar/index';
import UpperTab from './components/UpperTab/index';
import DetailsTab from './components/DetailsTab/index';
import Footer from './components/Footer/index';

export default {
  name: 'CompanyDetails',
  components: {
    Header,
    Toolbar,
    UpperTab,
    DetailsTab,
    Footer,
  },
  metaInfo: function () {
    return {
      title: this.company.name,
    }
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('companies', ['companyById']),
    company() {
      return this.companyById(this.companyId);
    },
    companyId() {
      return this.$route.params.id;
    },
    isVendor() {
      return (this.company.account_AccountTypes != undefined) ? this.company.account_AccountTypes.filter(x => x.accountTypeId == 3).length > 0 : false;
    },
    isCustomer() {
      return (this.company.account_AccountTypes != undefined) ? this.company.account_AccountTypes.filter(x => x.accountTypeId == 1).length > 0 : false;
    }
  },
  watch: {
    companyId: function() {
      this.getById(this.companyId);
    },
  },
  methods: {
    ...mapActions('companies', ['getById']),
  },
  async mounted() {
    this.setContainerLoader(true);
    await this.getById(this.companyId).then(() => {
      this.setContainerLoader(false);
    }).catch(() => {
      this.setContainerLoader(false);
      //return back to listing page because error in fetch record
      this.$router.push({name: 'company.list'});
    });  
  },
};
</script>

<style lang="scss">
.company {
  &-header {
    background: #eee;
  }

  &-details {
    padding-bottom: 1.5rem;

    .container-fluid {
      overflow: hidden;
    }

    .breadcrumb {
      overflow: hidden;
    }

    #my-form {
      height: 100%;
      width: 100%;
      text-align: left;
    }

    #upper-tab {
      width: 100%;
      height: 100%;
      text-align: left;
    }

    #details-tab {
      width: 100%;
      height: 100%;
      text-align: left;
    }

    #footer {
      width: 100%;
      height: 60px;
      text-align: left;
      background-color: rgb(230, 233, 232);
    }
  }
}
</style>
